import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { TicketResponse } from '@/types/apps/ticket.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface TicketGraphQLServiceInterface {
    getFields(): Record<string, any>;
    getEntityName(): string;
}

type TicketListResponse = GqlListResponse<TicketResponse>;

export class TicketGraphQLService
    extends BaseService
    implements TicketGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'ticket';
    }

    public getFields(): Record<string, any> {
        return {
            address: true,
            assigneeId: true,
            assigneeName: true,
            cancelById: true,
            closeDate: true,
            code: true,
            completionStatus: true,
            contract: true,
            createdBy: true,
            createdDate: true,
            customerCode: true,
            customerContactId: true,
            customerId: true,
            customer: {
                name: true,
            },
            deletedAt: true,
            deletedBy: true,
            descriptionResult: true,
            id: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            name: true,
            note: true,
            opp: true,
            priorityId: true,
            reasonCancel: true,
            scheduledTime: true,
            ticketCreator: true,
            ticketCreatorId: true,
            ticketStatus: true,
            ticketTypeId: true,
            ticketType: {
                name: true,
                id: true,
            },
        };
    }

    public async index(query: string): Promise<TicketListResponse> {
        return this.fetchGqlList(query, this.getEntityName()).then(res => {
            return {
                ...res,
                items: res.items.map((item: TicketResponse) => ({
                    ...item,
                    customName: `${item.code} - ${item.name}`,
                })),
            };
        });
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('ticket', {
            userId: this.getQueryById(),
        });
    }
}
